// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyC29BQs5JI6S2wQQ4ZvENIUhGZPwmR2d5U',
    authDomain: 'chalkfaders-bab67.firebaseapp.com',
    databaseURL: 'https://chalkfaders-bab67.firebaseio.com',
    projectId: 'chalkfaders-bab67',
    storageBucket: 'chalkfaders-bab67.appspot.com',
    messagingSenderId: '236633504297',
    // appId: "1:236633504297:web:7b20f0c33fc86d7d1fba38",
    // measurementId: "G-D96E83P8JL"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
